import React from "react";
import Cameras from "../modules/Cameras";

export const CameraPage = () => {
  return <Cameras />;
};
